<template>
    <div id="show">
        <div class="box">
            <div id="title" class="title has-text-grey-dark"><i class="fa fa-th-list"></i> Categories</div>
        </div>
        <hr>
        <div class="box columns is-multiline">
            <div class="column is-12">
                <div class="field">
                  <label class="label">Id:</label>
                  <div class="control">
                    <span>{{item.id}}</span>
                  </div>
                </div>
            </div>
            <div class="column is-12">
                <div class="field">
                  <label class="label">Name:</label>
                  <div class="control">
                    <span>{{item.name}}</span>
                  </div>
                </div>
            </div>

            <div class="column is-2 is-offset-8 is-pulled-right"> 
                <router-link v-bind:to="{ name: 'category-edit', params: { id: item.id }}" class="button is-block is-warning">
                    Edit
                </router-link>                
            </div>
            <div class="column is-2 is-pulled-right"> 
                <a href="javascript:history.go(-1)" class="button is-block">
                    Back
                </a>                
            </div>                        
        </div>          
    </div>  
</template>

<script>
import CategoryRepo from '../../repos/CategoryRepo'
import lodash from 'lodash'

export default {
  name: 'categories-show',
  components: {},
  data() {
        return {
            repo: new CategoryRepo(this.$auth),
            item: {},
        }
  },
  created(){  
    this.getCategory(this.$route.params.id);
  },
  methods: {
    getCategory(id){
        this.repo.show(id).then(response => {            
            this.item = response.data.data;
        });         
    },
  },
  watch: {
       
  }
  
}
</script>

<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/components/categories/Show.vue